import { getMeControlIAccountFromAccountInfo } from './getMeControlIAccountFromAccountInfo';
/**
 * Converts an MSAL Account to a MeControl IAccount
 */
export const mapMsalToMecontrol = (account) => {
    if (!account) {
        return null;
    }
    const asMeControl = getMeControlIAccountFromAccountInfo(account);
    if (!(asMeControl === null || asMeControl === void 0 ? void 0 : asMeControl.memberName)) {
        return null;
    }
    return Object.assign(Object.assign({}, getMeControlIAccountFromAccountInfo(account)), { authenticatedState: 'signedIn' });
};
